
export const bankList = [
    {value: 'BTG', label: 'BTG'},
    {value: 'SICOOB', label: 'SICOOB'}
]